var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddingSidesXs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_135)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 20H162V78H34V20Z",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 20V22.0714H34.5V20H33.5ZM33.5 26.2143V30.3571H34.5V26.2143H33.5ZM33.5 34.5V38.6429H34.5V34.5H33.5ZM33.5 42.7857V46.9286H34.5V42.7857H33.5ZM33.5 51.0714V55.2143H34.5V51.0714H33.5ZM33.5 59.3571V63.5H34.5V59.3571H33.5ZM33.5 67.6429V71.7857H34.5V67.6429H33.5ZM33.5 75.9286V78H34.5V75.9286H33.5ZM162.5 78V75.9286H161.5V78H162.5ZM162.5 71.7857V67.6429H161.5V71.7857H162.5ZM162.5 63.5V59.3571H161.5V63.5H162.5ZM162.5 55.2143V51.0714H161.5V55.2143H162.5ZM162.5 46.9286V42.7857H161.5V46.9286H162.5ZM162.5 38.6429V34.5H161.5V38.6429H162.5ZM162.5 30.3571V26.2143H161.5V30.3571H162.5ZM162.5 22.0714V20H161.5V22.0714H162.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6464 48.6464C15.4512 48.8417 15.4512 49.1583 15.6464 49.3536L18.8284 52.5355C19.0237 52.7308 19.3403 52.7308 19.5355 52.5355C19.7308 52.3403 19.7308 52.0237 19.5355 51.8284L16.7071 49L19.5355 46.1716C19.7308 45.9763 19.7308 45.6597 19.5355 45.4645C19.3403 45.2692 19.0237 45.2692 18.8284 45.4645L15.6464 48.6464ZM26.3536 49.3536C26.5488 49.1583 26.5488 48.8417 26.3536 48.6464L23.1716 45.4645C22.9763 45.2692 22.6597 45.2692 22.4645 45.4645C22.2692 45.6597 22.2692 45.9763 22.4645 46.1716L25.2929 49L22.4645 51.8284C22.2692 52.0237 22.2692 52.3403 22.4645 52.5355C22.6597 52.7308 22.9763 52.7308 23.1716 52.5355L26.3536 49.3536ZM16 49.5H26V48.5H16V49.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.646 48.6464C169.451 48.8417 169.451 49.1583 169.646 49.3536L172.828 52.5355C173.024 52.7308 173.34 52.7308 173.536 52.5355C173.731 52.3403 173.731 52.0237 173.536 51.8284L170.707 49L173.536 46.1716C173.731 45.9763 173.731 45.6597 173.536 45.4645C173.34 45.2692 173.024 45.2692 172.828 45.4645L169.646 48.6464ZM180.354 49.3536C180.549 49.1583 180.549 48.8417 180.354 48.6464L177.172 45.4645C176.976 45.2692 176.66 45.2692 176.464 45.4645C176.269 45.6597 176.269 45.9763 176.464 46.1716L179.293 49L176.464 51.8284C176.269 52.0237 176.269 52.3403 176.464 52.5355C176.66 52.7308 176.976 52.7308 177.172 52.5355L180.354 49.3536ZM170 49.5H180V48.5H170V49.5Z",
    fill: "#007FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingSidesXs);
export default __webpack_public_path__ + "static/media/padding_sides_xs.7e5031e6259d7f8504ed7995a4b669c7.svg";
export { ForwardRef as ReactComponent };